import { createContext } from 'react'

/** Where pop-ups should portal to; a modal Dialog sets it so lists drawn in it count as inside it. */
export const PortalContainerContext = createContext<HTMLElement | null>(null)
